import { Alert, Box } from "@mui/material"
import type { ReactElement } from "react"
import React, { useState } from "react"

import type { Contact } from "@/graphql/codegen/graphql"
import ContactCard from "@/screens/Companies/edit/components/locations/components/ContactCard"
import ContactCardTitle from "@/screens/Companies/edit/components/locations/components/ContactCardTitle"

const PrimaryContactInfo = ({
  primaryContact,
  handleEditPrimaryContact,
  locationId,
  onRefresh,
}: {
  primaryContact: Contact | null
  handleEditPrimaryContact: () => void
  locationId: string
  onRefresh?: () => void
}): ReactElement => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <>
      <Box className='flex items-center p-4'>
        <ContactCardTitle
          title='Location Primary Contact'
          label='Edit Location Primary Contact'
          onClick={handleEditPrimaryContact}
        />
      </Box>
      {!primaryContact ? (
        <Alert severity='error' className='mx-4'>
          Primary contact has not been designated for this location
        </Alert>
      ) : (
        <ContactCard
          contact={primaryContact}
          handleMenuOpen={handleMenuOpen}
          handleMenuClose={() => setAnchorEl(null)}
          anchorEl={anchorEl}
          className='mx-4 w-full'
          locationId={locationId}
          onRemoveSuccess={onRefresh}
        />
      )}
    </>
  )
}

export default PrimaryContactInfo
